import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import PanoramicView from './components/PanoramicView';
import Amenities from './components/Amenities';
import PropertyTypes from './components/PropertyTypes';
import Explore360 from './components/Explore360';

import ImageSlider3D from './components/ImageSlider3D';
import GetInTouch from './components/GetInTouch';
import Footer from './components/Footer';
import MapSection from './components/MapSection';
import LayoutSection from './components/LayoutSection';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <PanoramicView />
      <Amenities />
      <PropertyTypes />
      {/* <Contact /> */}
      <LayoutSection />
      <ImageSlider3D />
      <MapSection />
      <GetInTouch />
      <Footer />
    </div>
  );
}

export default App;
